<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<cnHeader @custom-event="getToken"></cnHeader>
		<div class="page_content">
			
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb">
					<a href="/cn">首页</a><span class="space">/</span><a href="/cn/user/index">我的账户</a><span class="space">/</span>自助下单
				</div>
			</div>
			<!--面包屑与公共提醒-结束-->
			
			<!--页面内容-开始-->
			<div class="booking_success_box">
				<div v-if="orderCheck">
					<h1>订单提交成功</h1>
					<h5>您的订单提交成功！我们会在两个工作天内给你发确认及付款通知，请注意查收邮件通知！<br />如需要帮忙请随时联络我们的客服，谢谢！</h5>
					<div class="success_img"></div>
					<div class="btns">
						<div class="btn blue"><a :href="'/cn/user/order_detail?OrderNo='+orderNo">查看订单详情</a></div>
						<div class="btn hollow"><a href="/cn/user/orders">查看全部订单</a></div>
					</div>
				</div>
				<div v-else style=" padding: 200px 0;">
					<h1>{{errMessage}}</h1>
				</div>
			</div>
			<!--页面内容-结束-->
		</div>
		<cnFooter></cnFooter>
	</div>
</template>


<script>
	import {
		checkToken,
		getOrderDetail,
		sendMail,
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	import cnHeader from '@/components/cn_header.vue'
	import cnFooter from '@/components/cn_footer.vue'
	export default {
		name: 'CN_UserBookingSuccess',
		mixins: [mixin],
		components: {
			cnHeader,
			cnFooter,
		},
		data() {
			return {
				orderNo: null,	//订单编号
				fullscreenLoading: true, //loading状态
				language: 'cn', //语言版本
				terminal: 'pc', //终端，pc
				loginStatus: false,	//登录态
				token: null, //token
				errMessage: '',
				orderDetail: [],	//订单详情
				orderCheck: false,	//订单验证
			}
		},
		created() {			
			// 获取orderNo
			if (this.$route.query.OrderNo != null && this.$route.query.OrderNo !='' && this.$route.query.OrderNo != undefined) {
				this.orderNo = this.$route.query.OrderNo
			}
		},
		methods: {
			//接收组件回传Token
			getToken(token)
			{
				this.token = token
				if(this.token !=null && this.token !='')
				{
					this.loginStatus = true					
					this.getData()
				}
				else				
				{
					this.$router.push({
						path: '/cn/user/login'
					})
				}
			},
			//获取订单详情
			async getData() {
				const { data: res } = await getOrderDetail(this.language, this.token, this.terminal, this.orderNo)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.orderDetail = res.data
					this.orderCheck = true
					
					//发送邮件
					this.sendMail(this.orderNo)
				} else {
					this.errMessage = res.errmsg
				}
			},
			//发送邮件
			async sendMail(orderNo)
			{
				//组装请求数据
				let params={
					Token: this.token,
					Terminal: this.terminal,
					Language: this.language,
					OrderNumber: orderNo,
				}
				
				const { data: res } = await sendMail(params)
				if (res.errcode === 0) {
					console.log('邮件发送成功')
				} else {
					console.log(res.errmsg)
				}
			},
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;

	}
</style>